'use client'
import { Link } from '@/i18n/navigation';
import Image from '@/components/atoms/image';
import React from 'react';

const FooterPartnerSection = ({ partnerTitle, partnerLogos, fundingTitle, fundingLogos }: any) => {
  return (
    <div className="">
      <div className="border-t border-white opacity-5" role="separator" aria-hidden="true"></div>
      <div className="container mx-auto py-32">
        <div className="flex flex-wrap flex-col xl:flex-row xl:items-center">
          <div className="">
            <h3 className="text-white text-m-regular">{partnerTitle}</h3>
          </div>
          <div className="flex flex-wrap py-16 xl:py-0 justify-start xl:justify-end items-center flex-1 gap-32">
            {partnerLogos.map((data: any, index: number) => (
              <Link
                key={index}
                href={data.url}
                target="_blank" 
                title={data.label}
                aria-label={data.label} 
                className="min-h-[44px] min-w-[44px]  inline-flex justify-center items-center"
              >
                <Image alt={data.logo.alt} src={data?.logo?.url} height={37} width={127} />
              </Link>
            ))}
          </div>
        </div>
      </div>
      
      <div className="border-t border-white opacity-5" role="separator" aria-hidden="true"></div>
      <div className="container mx-auto py-32">
        <div className="flex flex-wrap flex-col xl:flex-row xl:items-center">
          <div className="">
            <h3 className="text-white text-m-regular">{fundingTitle}</h3>
          </div>
          <div className="flex flex-wrap py-16 xl:py-0 justify-start xl:justify-end items-center flex-1 gap-32">
            {fundingLogos.map((data: any, index: number) => (
              <Link
                key={index}
                href={data.url} 
                target="_blank" 
                title={data?.label}
                aria-label={data?.label}
                className="min-h-[44px] min-w-[44px] inline-flex justify-center items-center"
              >
                <Image  height={37} width={127} alt={data.logo?.alt} src={data?.logo?.url} />
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white opacity-5" role="separator" aria-hidden="true"></div>
    </div>
  );
};

export default FooterPartnerSection;
